const PLUGIN_DOCUMENT_FIELDS = `
  documentId pluginId docType docSchemaVersion title state payloadJSON thumbKey
  createdAt updatedAt deleted version
`;
export const SURF_GRAPHQL = {
    deltaSync: /* GraphQL */ `
    query SurfDeltaSync($input: SyncInput!) {
      deltaSync(input: $input) {
        pluginDocuments { ${PLUGIN_DOCUMENT_FIELDS} }
        syncedAt
        nextToken
      }
    }
  `,
    putPluginDocument: /* GraphQL */ `
    mutation SurfPutPluginDocument($input: PutPluginDocumentInput!) {
      putPluginDocument(input: $input) {
        ${PLUGIN_DOCUMENT_FIELDS}
      }
    }
  `,
    updatePluginDocument: /* GraphQL */ `
    mutation SurfUpdatePluginDocument($documentId: ID!, $input: UpdatePluginDocumentInput!) {
      updatePluginDocument(documentId: $documentId, input: $input) {
        ${PLUGIN_DOCUMENT_FIELDS}
      }
    }
  `,
    deletePluginDocument: /* GraphQL */ `
    mutation SurfDeletePluginDocument($documentId: ID!) {
      deletePluginDocument(documentId: $documentId)
    }
  `,
    listNotes: /* GraphQL */ `
    query SurfListNotes($limit: Int, $nextToken: String) {
      listNotes(limit: $limit, nextToken: $nextToken) {
        items {
          noteId
          title
          updatedAt
          deleted
        }
        nextToken
      }
    }
  `,
    getNote: /* GraphQL */ `
    query SurfGetNote($noteId: ID!) {
      getNote(noteId: $noteId) {
        noteId
        title
        content
        pdfS3Key
        updatedAt
      }
    }
  `,
    submitAIJob: /* GraphQL */ `
    mutation SurfSubmitAIJob($input: SubmitAIJobInput!) {
      submitAIJob(input: $input) {
        jobId
        kind
        status
        feature
        createdAt
      }
    }
  `,
    getAIJob: /* GraphQL */ `
    query SurfGetAIJob($jobId: ID!) {
      getAIJob(jobId: $jobId) {
        jobId
        status
        feature
        paramsJson
        providerUsageJson
        outputAssetKey
        outputAssetMime
        errorMessage
        errorCode
        costCents
      }
    }
  `,
    listAIJobs: /* GraphQL */ `
    query SurfListAIJobs($appId: String, $limit: Int, $nextToken: String) {
      listAIJobs(appId: $appId, limit: $limit, nextToken: $nextToken) {
        items {
          jobId
          appId
          kind
          status
          feature
          prompt
          progress
          errorMessage
          errorCode
          clientLogLinesJson
          costCents
          createdAt
          updatedAt
          completedAt
        }
        nextToken
      }
    }
  `,
    upsertProfile: /* GraphQL */ `
    mutation SurfUpsertProfile {
      upsertProfile {
        userId
      }
    }
  `,
};
